import { render, staticRenderFns } from "./ComboAno.vue?vue&type=template&id=5adc76c4"
import script from "./ComboAno.vue?vue&type=script&lang=ts"
export * from "./ComboAno.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports